<template>
  <div
    class="app-layout"
    :class="{
      'menu-collapsed': isMenuCollapsed,
      'menu-mobile-open': isMobileMenuOpen
    }"
  >
    <header class="menu-top">
      <div class="menu-top-left">
        <button
          type="button"
          class="btn-menu-toggle"
          :aria-label="isMenuCollapsed ? 'Expandir menu' : 'Recolher menu'"
          @click="toggleSidebar"
        >
          <i class="material-icons">{{ isMenuCollapsed ? 'menu' : 'menu_open' }}</i>
        </button>

        <img
          class="logo-menu"
          alt="Brasil Agritest Logo"
          src="@/assets/images/logo.png"
          @click="navigateToHome"
        >
      </div>

      <div class="after-icon">
        <div class="profile" v-b-modal.modal-multi-1>
          <div class="profile-btn">
            <img
              class="profile-image"
              src="@/assets/images/Picture.png"
            >

            <b-modal
              body-class="my-class"
              id="modal-multi-1"
              size="md"
              centered
              no-stacking
              hide-header
              hide-footer
            >
              <div
                class="d-block text-center mt-1 infos"
                style="margin: 20px;"
              >
                <h4>{{ this.$store.state.user.name }}</h4>
                <h6>{{ this.$store.state.user.email }}</h6>
              </div>

              <b-button
                class="mt-2 edit"
                variant="ligth"
                block
                @click="edit"
              >
                Editar Perfil
              </b-button>

              <b-button
                class="mt-2 logout"
                variant="ligth"
                block
                @click="logout"
              >
                Sair
              </b-button>
            </b-modal>
          </div>

          <div class="profile-info">
            <h6 class="name">
              {{ this.$store.state.user.name }}
            </h6>

            <h6 class="email">
              {{ this.$store.state.user.email }}
            </h6>
          </div>
        </div>
      </div>
    </header>

    <div
      v-if="isMobile"
      class="sidebar-backdrop"
      :class="{ visible: isMobileMenuOpen }"
      @click="isMobileMenuOpen = false"
    />

    <aside class="sidebar" :class="{ collapsed: isMenuCollapsed }">
      <nav class="sidebar-nav">
        <router-link
          v-for="tab in tabs"
          :key="tab.key"
          :to="{ name: tab.key }"
          tag="div"
          active-class="current-page"
          :exact="tab.root"
          class="menu-link"
          @click.native="onNavClick"
        >
          <div
            class="menu-item"
            v-b-tooltip.hover.right="tooltipConfig(tab.title)"
          >
            <i :class="getTabIcon(tab.key)" class="menu-icon" />
            <span v-show="!isMenuCollapsed" class="menu-text">{{ tab.title }}</span>
          </div>
        </router-link>
      </nav>
    </aside>

    <main class="slot-page">
      <slot />
    </main>
  </div>
</template>

<style lang="stylus" scoped>
@import '../../style/colors.styl'
@import '../../style/dimens.styl'
@import '../../style/fonts.styl'
@import '../../style/mixins.styl'
@import '../../style/spacing.styl'

.app-layout
  --menu-top-height 72px
  --sidebar-width 200px
  --content-padding 24px
  min-height 100vh

.menu-collapsed
  --sidebar-width 72px

.menu-top
  z-index z-modal
  position fixed
  top 0
  left 0
  right 0
  height var(--menu-top-height)
  background-color secondary
  display flex
  align-items center
  justify-content space-between
  padding 0 space-md 0 0

.menu-top-left
  display flex
  align-items center
  gap space-sm
  height 100%
  min-width var(--sidebar-width)
  padding-left space-md
  transition min-width transition-base

.btn-menu-toggle
  display flex
  align-items center
  justify-content center
  width 40px
  height 40px
  padding 0
  border none
  border-radius radius-md
  background transparent
  color accent
  cursor pointer
  flex-shrink 0
  transition all transition-base

  .material-icons
    font-size 28px

  &:hover
    background-color rgba(255, 140, 66, 0.12)
    color primary

.logo-menu
  cursor pointer
  max-height 48px
  width auto
  object-fit contain
  transition transform transition-base

  &:hover
    transform scale(1.03)

.after-icon
  display flex
  align-items center
  flex 1
  justify-content flex-end
  min-width 0

.profile
  color accent
  margin 0 space-lg 0 auto
  display flex
  align-items center
  cursor pointer
  transition all transition-base
  padding space-sm space-md
  border-radius radius-lg

  &:hover
    background-color rgba(255, 140, 66, 0.08)
    color primary

.profile-info
  margin-left space-md
  display grid
  font-family Roboto-Medium
  color black
  row-gap space-xs

.name
  font-size 1rem
  font-weight 600

.email
  font-size 0.875rem
  color #6c757d

.profile-btn
  display flex
  align-items center

.profile-image
  width 45px
  height 45px
  border-radius 50%
  border 2px solid accent
  transition all transition-base
  object-fit cover

  &:hover
    border-color primary
    transform scale(1.05)

h6
  color accent
  font-family Rubik-Medium
  margin 0

h4
  color black
  font-family Rubik-Regular

.edit,
.logout
  border-color accent
  border-radius radius-pill
  color accent
  font-weight 600
  transition all transition-base

  &:hover
    color white
    background linear-gradient(135deg, primary 0%, #FF7A29 100%)
    border-color primary
    transform translateY(-1px)
    box-shadow shadow-orange

.sidebar-backdrop
  display none

.sidebar
  position fixed
  top var(--menu-top-height)
  left 0
  width var(--sidebar-width)
  height calc(100vh - var(--menu-top-height))
  background-color white
  box-shadow shadow-md
  z-index z-fixed
  transition width transition-base, transform transition-base
  overflow-x hidden
  overflow-y auto

.sidebar-nav
  display flex
  flex-direction column
  padding space-md space-sm

.menu-link
  text-decoration none
  color inherit

.menu-item
  display flex
  align-items center
  justify-content flex-start
  min-height 48px
  padding space-sm space-md
  margin-bottom space-xs
  border-radius radius-md
  cursor pointer
  transition all transition-fast
  position relative

  &:hover
    background-color rgba(255, 140, 66, 0.08)

.menu-collapsed .menu-item
  justify-content center
  padding space-sm

.menu-icon
  font-size 22px
  color primary
  width 28px
  min-width 28px
  display flex
  align-items center
  justify-content center
  flex-shrink 0
  transition margin transition-base

.menu-text
  font-family 'Manrope', sans-serif
  font-weight 600
  font-size 14px
  color #555
  margin-left space-md
  white-space nowrap
  overflow hidden
  text-overflow ellipsis
  line-height 1.2

.menu-collapsed .menu-text
  width 0
  margin 0
  opacity 0

.current-page .menu-item
  background-color rgba(255, 140, 66, 0.12)

  &::before
    content ''
    position absolute
    left 0
    top space-xs
    bottom space-xs
    width 4px
    border-radius 0 radius-sm radius-sm 0
    background-color primary

.slot-page
  margin-left var(--sidebar-width)
  margin-top var(--menu-top-height)
  min-height calc(100vh - var(--menu-top-height))
  padding var(--content-padding)
  transition margin-left transition-base, padding transition-base
  width calc(100% - var(--sidebar-width))
  box-sizing border-box

// Tablet
@media (max-width: 991px)
  .menu-top-left
    min-width auto
    padding-left space-sm

  .profile
    margin-right space-md

  .slot-page
    width 100%

// Mobile
@media (max-width: 768px)
  .app-layout:not(.menu-mobile-open)
    --sidebar-width 0px

  .sidebar
    transform translateX(-100%)
    width 260px
    max-width 85vw

  .menu-mobile-open .sidebar
    transform translateX(0)

  .sidebar-backdrop
    display block
    position fixed
    top var(--menu-top-height)
    left 0
    right 0
    bottom 0
    background rgba(0, 0, 0, 0.4)
    z-index z-modal-backdrop
    opacity 0
    pointer-events none
    transition opacity transition-base

    &.visible
      opacity 1
      pointer-events auto

  .menu-mobile-open .slot-page
    margin-left 0
    width 100%

  .profile
    margin space-xs space-sm space-xs auto
    padding space-xs

  .profile-info
    margin 0 space-sm 0 space-sm

@media (max-width: 576px)
  .logo-menu
    max-height 40px

  .profile-info
    max-width 120px

  .name,
  .email
    white-space nowrap
    overflow hidden
    text-overflow ellipsis

@media (max-width: 400px)
  .profile-info
    display none
</style>

<style lang="stylus">
/* Alinhamento global dos cabeçalhos das páginas no slot */
.slot-page .page-header,
.slot-page .page-header-left,
.slot-page > div > .d-flex:first-child,
.slot-page > div > .d-flex:first-child .d-flex.align-items-center
  margin-top 0
  margin-left 0
  padding-left 0
  align-items center

.slot-page .page-header-left,
.slot-page > div > .d-flex:first-child .d-flex.align-items-center,
.slot-page > div > .d-flex.align-items-center:first-child
  gap 1.25rem

.slot-page .page-title,
.slot-page h1.page-title
  margin-top 0
  margin-bottom 0
  margin-left 0 !important

.slot-page .btn-back
  flex-shrink 0
  margin-right 0
</style>

<script>
/* eslint-disable */

const SIDEBAR_COLLAPSED_KEY = 'agritest-menu-collapsed'

const TAB_ICONS = {
  analises: 'fas fa-microscope',
  melhorias: 'fas fa-tools',
  funcionarios: 'fas fa-user-tie',
  empresas: 'fas fa-building',
  equipamentos: 'fas fa-tools',
  estatisticas: 'fas fa-chart-line',
}

export default {
  data() {
    const saved = localStorage.getItem(SIDEBAR_COLLAPSED_KEY)
    return {
      isMenuCollapsed: saved === 'true',
      isMobileMenuOpen: false,
      isMobile: false
    }
  },

  computed: {
    tabs() {
      let menuItens = []

      if (this.$store.getters.isSuperAdmin) {
        menuItens = [
          'analises',
          'melhorias',
          'funcionarios',
          'empresas',
          'equipamentos',
          'estatisticas'
        ]
      } else if (this.$store.getters.isManager) {
        menuItens = [
          'analises',
          'melhorias',
          'funcionarios',
          'estatisticas'
        ]
      } else if (this.$store.getters.isOperator) {
        menuItens = ['analises']
      } else if (this.$store.getters.isReadOnly) {
        menuItens = [
          'analises',
          'melhorias',
          'funcionarios',
          'empresas',
          'equipamentos',
          'estatisticas'
        ]
      }

      const tabs = []

      menuItens.forEach(item => {
        const state = this.$store.state[item]

        if (state && !state.noMenu) {
          tabs.push(
            Object.assign(
              {},
              state.menu,
              {
                key: item,
                root: state.root
              }
            )
          )
        }
      })

      return tabs
    }
  },

  mounted() {
    this.updateViewport()
    window.addEventListener('resize', this.updateViewport)
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.updateViewport)
  },

  methods: {
    getTabIcon(key) {
      return TAB_ICONS[key] || 'fas fa-circle'
    },

    tooltipConfig(title) {
      if (!this.isMenuCollapsed || this.isMobile) {
        return { disabled: true }
      }
      return {
        title,
        boundary: 'viewport',
        delay: { show: 200, hide: 50 }
      }
    },

    updateViewport() {
      this.isMobile = window.innerWidth <= 768
      if (!this.isMobile) {
        this.isMobileMenuOpen = false
      }
    },

    toggleSidebar() {
      if (this.isMobile) {
        this.isMobileMenuOpen = !this.isMobileMenuOpen
        return
      }
      this.isMenuCollapsed = !this.isMenuCollapsed
      localStorage.setItem(SIDEBAR_COLLAPSED_KEY, String(this.isMenuCollapsed))
    },

    onNavClick() {
      if (this.isMobile) {
        this.isMobileMenuOpen = false
      }
    },

    logout() {
      this.$store.dispatch('logout')
      this.$router.replace({ name: 'Login' })
    },

    edit() {
      this.$router.replace({
        name: 'Edit',
        params: {
          userId: this.$store.state.user.id
        }
      })
    },

    navigateToHome() {
      if (this.$route.path !== '/') {
        this.$router.push('/')
      }
      if (this.isMobile) {
        this.isMobileMenuOpen = false
      }
    }
  }
}
</script>